export const quotes_containers_displayed_columns_locale  = {
  containerIsoCodeDescription: "Size type",
  grossWeight: "Gross weight"
};
